import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-c1d3d5ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "map-modal" };
const _hoisted_2 = { class: "btn-pos" };
import { computed } from "vue";
import { GoogleMap, Marker } from "vue3-google-map";
import DButton from "@/components/button/SubmitButton.vue";
// Define props
export default /*#__PURE__*/ _defineComponent({
    __name: 'GMap',
    props: {
        lat: {
            type: String,
            required: true,
        },
        lng: {
            type: String,
            required: true,
        },
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // Define emit event
        const emit = __emit;
        // Computed property for the map center
        const center = computed(() => ({
            lat: Number(props.lat),
            lng: Number(props.lng),
        }));
        // Emit an event when the button is clicked
        function handleClose() {
            emit("close", "Button clicked from Child");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(GoogleMap), {
                    style: { "width": "100%", "height": "100%" },
                    center: center.value,
                    zoom: 15
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(Marker), {
                            options: { position: center.value }
                        }, null, 8, ["options"])
                    ]),
                    _: 1
                }, 8, ["center"]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(DButton, {
                        primary: "",
                        value: "Close",
                        onClick: handleClose
                    })
                ])
            ]));
        };
    }
});
